import React from "react";
import { TextBox } from "@progress/kendo-react-inputs";
import { ICON_BASE_PATH } from "../../../../utils/config";

interface SearchInputProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  placeholder?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  searchQuery,
  onSearchChange,
  placeholder,
}) => {
  return (
    <div className="relative gx_searchinput gx-font-medium w-full">
      <TextBox
        type="text"
        value={searchQuery || ""}
        placeholder={placeholder}
        onChange={(e) => onSearchChange(String(e.value || ""))}
        className="w-full pr-10"
      />

      <div
        className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer z-10"
        onClick={() => {
          onSearchChange("");
        }}
      >
        {searchQuery ? (
          <img src={`${ICON_BASE_PATH}close-icon.svg`} alt="clear" className="gx-close-icon" />
        ) : (
          <img src={`${ICON_BASE_PATH}search.svg`} alt="search" />
        )}
      </div>
    </div>
  );
};

export default SearchInput;
